import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock, LogIn } from "lucide-react";
import { login, setToken, hasToken } from "@/lib/api";
import { LOGO_ICON, BRAND } from "@/lib/contact";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (hasToken()) navigate(next, { replace: true });
  }, [navigate, next]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      setToken(data.access_token);
      toast.success("مرحبًا بك 👋");
      navigate(next, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "تعذّر تسجيل الدخول");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-right text-white outline-none focus:border-gold transition placeholder:text-white/40";

  return (
    <div className="min-h-screen gradient-primary grain flex items-center justify-center px-6" dir="rtl">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_ICON} alt={BRAND} className="w-16 h-16 rounded-2xl object-cover ring-1 ring-gold/50 mx-auto mb-4" />
          <h1 className="font-serif text-3xl font-bold text-white">لوحة تحكم {BRAND}</h1>
          <p className="text-white/60 text-sm mt-2">سجّل الدخول لإدارة موقعك</p>
        </div>
        <form onSubmit={submit} className="glass rounded-2xl border border-white/10 p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-sm mb-2 text-white/70">البريد الإلكتروني</label>
            <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@y9.store" data-testid="login-email-input" />
          </div>
          <div>
            <label className="block text-sm mb-2 text-white/70">كلمة المرور</label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute right-3 top-1/2 -translate-y-1/2 text-white/40" />
              <input type="password" className={inputCls + " pr-10"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" />
            </div>
          </div>
          <button type="submit" disabled={loading} className="w-full flex items-center justify-center gap-2 rounded-xl bg-gold py-3.5 font-semibold disabled:opacity-60 transition hover:brightness-105" style={{ color: "#232a44" }} data-testid="login-submit-btn">
            {loading ? "جارٍ الدخول..." : "دخول"} <LogIn className="w-4 h-4" />
          </button>
        </form>
      </motion.div>
    </div>
  );
}
